export const DeleteAccountRoutes = [
    {
        "url": "/settings",
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["delete-account"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/delete-account/delete-account.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/:view?tab&section",
        "name": "appLayout.harriSH.settings.section",
        "type": "frontend",
        "params": {},
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["delete-account"]
        }
    }
];
//# sourceMappingURL=delete-account.routes.js.map